/**
 * /orgs/:orgId/groups — the tenant's access model.
 *
 * Named Groups, not "Members & groups", because after Feature 32 a group is
 * the ONLY ACL grant: it is the join between the people who may ask and the
 * data they may reach. A member list with a groups column buries the entity
 * that actually governs retrieval.
 *
 * The two failure states this framing exposes, neither of which a member list
 * can show:
 *   - a group with members but no collections grants nothing;
 *   - a group with collections but no members makes those documents
 *     unreachable by anyone.
 *
 * The collections half needs an endpoint that does not exist yet — the groups
 * API is members-only, and documents carry `allowed_groups` but groups have no
 * route to their documents. Until that lands the page ships members-first.
 */
import { useRequiredOrgId } from '../../lib/use-current-org.js';
import { ListShape } from '../../ui/shapes.js';
import { GroupsTab } from '../collections/GroupsTab.js';

export function OrgGroupsPage() {
  const orgId = useRequiredOrgId();
  return (
    <ListShape
      title="Groups"
      subtitle="A group is the only ACL grant — it joins the people who may ask to the data they may reach."
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 22, paddingBottom: 64 }}>
        <GroupsTab organizationId={orgId} />
      </div>
    </ListShape>
  );
}
